import { faHourglass } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CardContent, CardMedia, NavCard } from '@partful/pages/product-library/root/Card';
import { Badge } from '@partful/shared/ui/Badge';
import { Job } from '@providers/job/types';
import { useTranslation } from 'react-i18next';
import styles from './SalesBOMInProgressCard.module.scss';

type InProgressCardProps = {
  job: Job;
  redirectURL: string;
};

export default function InProgressCard({ job, redirectURL }: Readonly<InProgressCardProps>) {
  const { card, content, rotateIcon, textContent, badge } = styles;
  const { t } = useTranslation('productLibrary');

  return (
    <NavCard to={redirectURL} className={card}>
      <CardMedia className={content}>
        <FontAwesomeIcon icon={faHourglass} className={rotateIcon} size="5x" />
        <h3>{t('salesBOM.processing', { name: job.productName })}</h3>
        <p>{t('pleaseComeBackSoon')}</p>
      </CardMedia>
      <CardContent className={textContent}>
        <h3>{job.productName}</h3>
        <Badge variant="error" className={badge}>
          {t('inProgress')}
        </Badge>
      </CardContent>
    </NavCard>
  );
}
